















































import { Vue, Component, Provide } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import { mapGetters } from "vuex"
import { Columns } from "./constant"
import manageService from "@/services/manage.service"
import ItemTable from "./itemTable.vue"
@Component({
    name: "VersionList",
    components: {
        PageHeader,
        ItemTable
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["productSubTypeMap"])
    }
})
export default class VersionList extends Vue {
    readonly currentUser: any
    readonly productSubTypeMap: any
    pagination = {
        current: 1,
        pageSize: 20,
        showQuickJumper: false,
        showSizeChanger: true,
        total: 0
    }
    dataSource: any[] = []
    // software_id:版本列表右面的筛选
    software_id: any = null
    software_list: any = []
    product_list: any = []
    currentProductId = 1
    userRoles: { system_roles: any[] } = { system_roles: [] }

    @Provide()
    get useWrapperContext() {
        return this
    }
    // 当前产品线有多少个产品（tab）
    get currentProductList() {
        return this.product_list.filter((item: any) => {
            return item.software_id === this.software_id
        })
    }

    get columns() {
        const cols: any = [
            {
                title: "版本名称",
                dataIndex: "version_name",
                key: "version_name",
                width: 200
            }
        ]
        return [...cols, ...Columns]
    }

    productFullNameGetter(product: any) {
        const { product_name, product_sub_type } = product
        return `${product_name || "-"}（${this.productSubTypeMap[product_sub_type] || "-"}）`
    }
    //表格mounted会自己请求一次 为了避免重复请求 加上标识
    isFirstIntoView = true
    async activated() {
        if (this.isFirstIntoView) {
            await this.getUserSoftware()
            const query_software_id = Number(this.$route.query.software_id || null)
            this.software_id = query_software_id || this.software_list[0]?.software_id || undefined
            await this.getUserProduct()
            this.isFirstIntoView = false
        }
    }

    async changeSoftware() {
        this.currentProductId = this.currentProductList[0]?.product_id
    }

    async getUserSoftware() {
        try {
            const res = await manageService.getUserSoftware({
                uid: this.currentUser.uid
            })
            const { list = [] } = res || {}
            this.software_list = list || []
        } catch (error) {
            this.$message.error(`${error}, 获取产品线列表失败！`)
        }
    }

    async getUserProduct() {
        try {
            if (!this.software_id) {
                this.product_list = []
                return
            }
            // 获取用户可见的全部产品名称
            const res = await manageService.getUserProduct({
                uid: this.currentUser.uid
            })
            const { list = [] } = res || {}
            this.product_list = list || []
        } catch (error) {
            this.$message.error(`${error}, 获取产品列表失败！`)
        }
    }
}
